import _sfc_main from "./MultiStreamViewH5.vue2.mjs";
/* empty css                        */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "multiStreamViewRef", staticClass: "multi-stream-view" }, [!_setup.isEqualPointsLayout || _setup.totalPageNumber === 1 ? _c(_setup.StreamList, { attrs: { "streamInfoList": _setup.renderStreamInfoList, "column": _setup.column, "row": _setup.row, "streamPlayMode": _vm.streamPlayMode || _setup.StreamPlayMode.PLAY_IN_VISIBLE, "streamPlayQuality": _setup.StreamPlayQuality.Default, "aspect-ratio": _setup.aspectRatio }, on: { "stream-view-dblclick": _setup.handleStreamViewDblclick } }) : _vm._e(), _setup.isEqualPointsLayout && _setup.totalPageNumber > 1 ? _c(_setup.TuiSwiper, { attrs: { "activeIndex": _setup.currentPageIndex, "show-page-dots": _setup.totalPageNumber > 1 }, on: { "change": _setup.handleActiveIndexChange } }, _vm._l(_setup.totalPageNumber, function(item, index) {
    return _c(_setup.TuiSwiperItem, { key: index }, [_c(_setup.StreamList, { attrs: { "streamInfoList": _setup.equalPointsLayoutStreamList[index], "column": _setup.column, "row": _setup.row, "streamPlayMode": _setup.getStreamPlayMode(index), "streamPlayQuality": _setup.StreamPlayQuality.Default, "aspect-ratio": _setup.aspectRatio }, on: { "stream-view-dblclick": _setup.handleStreamViewDblclick } })], 1);
  }), 1) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "829bdd47"
);
const MultiStreamViewH5 = __component__.exports;
export {
  MultiStreamViewH5 as default
};
